import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "danger";
type Size = "sm" | "md";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const BASE: Record<Variant, string> = {
  primary:
    "bg-ink text-paper border-0 rounded-full font-sans font-medium text-sm cursor-pointer inline-flex items-center justify-center gap-2 transition-all duration-150 tracking-[0.01em] hover:bg-moss",
  secondary:
    "bg-cream-2 text-ink border-0 rounded-full font-sans font-medium text-sm cursor-pointer hover:bg-line",
  danger:
    "inline-flex items-center gap-1.5 bg-transparent rounded-[10px] font-sans font-medium cursor-pointer tracking-[0.01em] border-[1.5px] text-[oklch(0.5_0.14_28)] border-[oklch(0.78_0.1_28)] hover:bg-[oklch(0.95_0.04_28/0.6)] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent",
};

const SIZE: Record<Variant, Record<Size, string>> = {
  primary: { md: "px-5 py-3.25", sm: "px-3.5 py-2.25 text-[13px]" },
  secondary: { md: "px-5 py-3.25", sm: "px-3.5 py-2.25 text-[13px]" },
  danger: { md: "px-4 py-2.5 text-[13px]", sm: "px-3.5 py-2 text-xs" },
};

export function Button({
  variant = "primary",
  size = "md",
  className,
  ...rest
}: ButtonProps) {
  const classes = `${BASE[variant]} ${SIZE[variant][size]}${className ? ` ${className}` : ""}`;
  return <button className={classes} {...rest} />;
}
